import React from "react";
import styled from "styled-components";

export const Title = styled((props) => <div {...props} />).attrs((props) => ({
  automationid:
    props.automationid ||
    `SalesLead_div_${props?.automationidattr?.replace(/ /g, "")}_1"`,
}))`
  font-family: "Roboto";
  font-weight: 700;
  color: ${(props) => (props.color ? props.color : "#282828")};
  font-size: 2rem;

  @media only screen and (max-width: 450px) {
    font-size: 25px;
  }
`;
